import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../../app.component';
import { bmxurl } from 'src/globals';
import { getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BusyService } from '../../_services/busy.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { GlobalService } from '../../_services/global.service';
import { MenuItem } from 'primeng/api';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { cBookingfee } from 'src/types/bookingfee';
import { bookingfee_returndata } from 'src/types/bookingfee_returndata';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { users_returndata } from 'src/types/user_returndata';
import { cColumninfo } from 'src/types/columninfo';

@Component({
  selector: 'app-extrasreport',
  templateUrl: './extrasreport.component.html',
  styleUrls: ['./extrasreport.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExtrasreportComponent  implements OnInit {
  ListBookings: any[];
  ListBookingsGlobal: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  BookingDate: Date;
  PreviousBookingDate: Date;
  hubConnection: HubConnection;
  httpResponse: any;
  navSubscription: Subscription = null;
  bookingsInProgress: number = 0;
  totalBookingsToday: number = 0;
  inProgress: boolean = false;

  bcItems: MenuItem[];
  home: MenuItem;
  PreviousHubs: string[] = [];
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = "-";

  guests:number = 0;
  total:number = 0;


  cols: any[] = [];
  
  constructor(
    private http: HttpClient, 
    private appComp: AppComponent, 
    private router: Router, 
    private messageService: MessageService, 
    private busyService: BusyService,
    private auth: AuthService,
    private globalService: GlobalService) {
      
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        // if(getAccess("EXTRAS", user)){
        //   this.AccessAllowed = true;
        // }
        // else
        // {
        //   this.AccessAllowed = false;
        // }

        this.CompletedLoading = true;
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });
    }

  ngOnDestroy() {
    this.hubConnection.stop();
  }

  showInProgress(){
    this.inProgress = true;
    this.loadgrid(false);
  }

  unshowInProgress(){ 
    this.inProgress = false;
    this.loadgrid(false);
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("EXTRAS", user)){
          this.AccessAllowed = true;
        }
        else
        {
          this.AccessAllowed = false;
        }

        localStorage.removeItem("screenMemoryBookingss");
        localStorage.removeItem("screenMemoryEvents");
        
        this.auth.getAccessTokenSilently().subscribe(tokenReturned => {
          this.hubConnection = new HubConnectionBuilder()
          .withUrl(environment.servicestarget + "/venue/" + this.VenueID, { 
          accessTokenFactory: () => tokenReturned 
        }).build();

        let menuItems: MenuItem[];

        let userid = localStorage.getItem("SmartUserID");
        
        this.BookingDate = new Date();

        let BookingDateYear = this.BookingDate.getFullYear();
        let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
        let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

        let BookingEventDate = "bookingEvent_" + BookingDateYear + BookingDateMonth + BookingDateDay;

        this.PreviousHubs.push(BookingEventDate);

        this.hubConnection.start();

        this.hubConnection.off(BookingEventDate);

        this.hubConnection.on(BookingEventDate, data => {
          this.loadgrid(false);
        });

        this.busyService.busy();
        
            //Get Settings and put them in Local Storage
            this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
              this.httpResponse =  (response as venuesettings_returndata)
              if(this.httpResponse.succeeded)
              {
                //Set Venue Settings ID
                localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);
        
                this.httpResponse.data.venueSettings.forEach(element => {
                  localStorage.setItem(element.name, element.value);
                });

                this.CurrencySymbol = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
                this.loadgrid(false);
              }
              else{
                this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
              }
            }, error => {
              this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
            });

        });

        // this.http.get(bmxurl + "bookingfee/" + this.VenueID).subscribe(response => {
        //   this.httpResponse = (response as bookingfee_returndata)
        //   if (this.httpResponse.succeeded)
        //   {
        //     if(this.httpResponse.data != null)
        //     {
        //       let BookingFee: cBookingfee = {
        //         id: (this.httpResponse.data as cBookingfee).id,
        //         name: (this.httpResponse.data as cBookingfee).name,
        //         venueid: (this.httpResponse.data as cBookingfee).venueid,
        //         disabled: (this.httpResponse.data as cBookingfee).disabled,
        //         bfid: (this.httpResponse.data as cBookingfee).bfid,
        //         isdefault: (this.httpResponse.data as cBookingfee).isdefault,
        //         bfpublicapply: (this.httpResponse.data as cBookingfee).bfpublicapply,
        //         bfadminapply: (this.httpResponse.data as cBookingfee).bfadminapply,
        //         bfpublicshowtext: (this.httpResponse.data as cBookingfee).bfpublicshowtext,
        //         bfpublictext: (this.httpResponse.data as cBookingfee).bfpublictext,
        //         bfpublictype: (this.httpResponse.data as cBookingfee).bfpublictype,
        //         bfadmintype: (this.httpResponse.data as cBookingfee).bfadmintype,
        //         bfpublicfee: (this.httpResponse.data as cBookingfee).bfpublicfee,
        //         bfpublicmin: (this.httpResponse.data as cBookingfee).bfpublicmin,
        //         bfpublicmax: (this.httpResponse.data as cBookingfee).bfpublicmax,
        //         bfadminfee: (this.httpResponse.data as cBookingfee).bfadminfee,
        //         bfadminmin: (this.httpResponse.data as cBookingfee).bfadminmin,
        //         bfadminmax: (this.httpResponse.data as cBookingfee).bfadminmax,
        //         bookingfeeappliestomemberspublic: (this.httpResponse.data as cBookingfee).bookingfeeappliestomemberspublic,
        //         bookingfeeappliedonmembershippurchasespublic: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasespublic,
        //         bookingfeeappliestomembersadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliestomembersadmin,
        //         bookingfeeappliedonmembershippurchasesadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasesadmin,
        //       };

        //       localStorage.setItem("VenueBookingFee", JSON.stringify(BookingFee));
        //     }
        //   }
        //   else
        //   {
        //     this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee'});
        //   }
        // }, error => {
        //   this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee, error:' + error.messages[0]});
        // });


      }
    });
  }

  editdata(ID){
    this.router.navigateByUrl("/editbooking/" + ID);
  }

  editdatanew(ID){
    this.router.navigateByUrl("/editbooking/" + ID);
  }

  loadgrid(showdisabled: boolean)
  {
    let BookingDateYear = this.BookingDate.getFullYear().toString().substr(-2);
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let dateChosen = BookingDateDay + BookingDateMonth + BookingDateYear;

    //this.busyService.busy();
    this.http.get(bmxurl + "GetBookingLisReport/" + this.VenueID + "/" + dateChosen + "/false").subscribe(response => {
      try{
        this.CreateUpdateResponse = (response as any);

        if(this.CreateUpdateResponse.data.length > 0) 
        {
          let importCols = Object.keys(this.CreateUpdateResponse.data[0]);

          this.cols = [];
          
          importCols.forEach(element => {
            
            let column = new cColumninfo;
            column.field = element;
            column.header = element;

            this.cols.push(column)
         });

         //total up the guests and total
          this.guests = 0;
          this.total = 0;

          this.CreateUpdateResponse.data.forEach(element => {
            this.guests += element.Guests;
            this.total += Number(element.Total);
          });

        }

        this.ListBookingsGlobal = this.CreateUpdateResponse.data;
        const isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
        this.ListBookingsGlobal.forEach(row => {
          Object.keys(row).forEach(key => {
            if (typeof row[key] === 'string' && isoDatePattern.test(row[key])) {
              row[key] = this.formatDateForExcel(row[key]);
            }
          });
        });
      }
      catch (error){
        this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'Failed to get bookings in loadgrid, possible data mismatch!'});
      }
      finally{
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'An error occurred getting Bookings'});
      this.busyService.idle();
    });
  }

  doneDate(){

    this.inProgress = false;

    this.loadgrid(false)

    this.PreviousHubs.forEach(element => {
      this.hubConnection.off(element);
    });

    this.PreviousHubs = [];

    let BookingDateYear = this.BookingDate.getFullYear();
    let BookingDateMonth = ('00' + (this.BookingDate.getMonth() + 1)).slice(-2);
    let BookingDateDay = ('00' + this.BookingDate.getDate()).slice(-2);

    let BookingEventDate = "bookingEvent_" + BookingDateYear + BookingDateMonth + BookingDateDay;

    this.PreviousHubs.push(BookingEventDate);

    this.hubConnection.on(BookingEventDate, data => {
      this.loadgrid(false);
    });

  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  dateChange(num)
  {
    this.BookingDate = this.addDays(new Date(this.BookingDate), num);
    this.doneDate();
  }

  exportData()
  {


  }

  formatDateForExcel(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const day = ('0' + d.getUTCDate()).slice(-2);
    const month = ('0' + (d.getUTCMonth() + 1)).slice(-2);
    const year = d.getUTCFullYear();
    const hours = ('0' + d.getUTCHours()).slice(-2);
    const minutes = ('0' + d.getUTCMinutes()).slice(-2);
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

}